var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, useRadioGroup } from '@mui/material';
import { useKey } from 'react-use';
export function Option(_a) {
    var label = _a.label, value = _a.value, shortcutKey = _a.shortcutKey;
    var radioGroup = useRadioGroup();
    var checked = false;
    if (radioGroup) {
        checked = radioGroup.value === value;
    }
    var handleClick = function () {
        radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange({ target: { value: value } }, value);
    };
    useKey(shortcutKey, !!shortcutKey ? handleClick : undefined);
    return (_jsx(Button, __assign({ variant: checked ? 'contained' : 'outlined', onClick: handleClick, role: "radio", "aria-checked": checked }, { children: label })));
}
export default Option;
